'use client';

import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { FaCalendarAlt, FaClock, FaUser } from 'react-icons/fa';

import Breadcrumb from '@/components/Breadcrumb';
import Header from '@/components/Header';

import { useLanguage } from '@/contexts/LanguageContext';

export default function BlogPage() {
  const { t: _t } = useLanguage();

  const blogPosts = [
    {
      id: 1,
      title: 'Botoks Fiyatları 2026 - Ne kadar, Neye Göre Değişiyor?',
      excerpt: 'Botoks fiyatlarını etkileyen faktörler ve 2026 güncel fiyat listesi. Botoks maliyetlerini bilmek isteyenler için detaylı rehber.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Estetik Tedaviler',
      slug: 'botoks-fiyatlari-2026',
      readTime: '5 dakika',
      publishDate: '15 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 2,
      title: 'Botoks Nedir ve Nasıl Yapılır? - Ayrıntılı Rehber',
      excerpt: 'Botoksun ne olduğu, nasıl çalıştığı ve uygulama sürecinin ayrıntılı anlatımı. Güvenli botoks uygulaması için bilinmesi gerekenler.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Estetik Tedaviler',
      slug: 'botoks-nedir-nasil-yapilir',
      readTime: '10 dakika',
      publishDate: '15 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 3,
      title: 'Alın Botoksu Nedir? Nasıl Yapılır ve Ne Kadar Sürer?',
      excerpt: 'Alın botoksu uygulaması, faydaları, maliyeti ve kalıcılığı hakkında bilinmesi gerekenler. 2026 güncel fiyat bilgileri.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Estetik Tedaviler',
      slug: 'alin-botoksu-nedir',
      readTime: '7 dakika',
      publishDate: '16 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 4,
      title: 'Kaz Ayağı Botoksu Nedir? Göz Çevresindeki Kırışıklıkların Çözümü',
      excerpt: 'Göz çevresi botoksu ile kaz ayağı kırışıklıklarını ortadan kaldırmak. Uygulama süreci, faydaları ve 2026 fiyat bilgileri.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Estetik Tedaviler',
      slug: 'kaz-ayagi-botoksu-nedir',
      readTime: '6 dakika',
      publishDate: '17 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 5,
      title: 'Botoksun Yan Etkileri ve Riskleri – Bilmeniz Gerekenler Neler?',
      excerpt: 'Botoks yan etkileri nelerdir? Riskler nasıl azaltılır? Botoks uygulaması öncesi bilinmesi gereken tüm yan etkiler ve güvenlik önlemleri.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Estetik Tedaviler',
      slug: 'botoks-yan-etkileri',
      readTime: '8 dakika',
      publishDate: '18 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 6,
      title: 'Botoks ile Dolgu Arasındaki Farklar – Hangi Uygulama Ne Zaman Tercih Edilmeli?',
      excerpt: 'Botoks mu dolgu mu? Her iki estetik uygulamanın farkları, kullanım alanları ve hangi durumlarda tercih edilmesi gerektiğini detaylı olarak öğrenin.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Estetik Tedaviler',
      slug: 'botoks-dolgu-farklari',
      readTime: '9 dakika',
      publishDate: '19 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 7,
      title: 'Nöroloji Doktorları Neden Botoks Önermez?',
      excerpt: 'Nöroloji uzmanları botoksu neden her hastaya önermez? Sinir-kas etkileri, kontrendikasyonları, riskleri ve bilimsel nedenleriyle tam açıklama.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Nöroloji & Botoks',
      slug: 'noroloji-doktorlari-neden-botoks-onermez',
      readTime: '12 dakika',
      publishDate: '20 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 8,
      title: 'Botoks Fiyatları Neden Bazı Muayenehanelerde Çok Ucuzken Bazı Muayenehanelerde Çok Pahalı?',
      excerpt: 'Botoks fiyatları neden bu kadar farklı? Ucuz ve pahalı botoks arasındaki fark, kullanılan ürün kalitesi, hekim deneyimi ve klinik koşullarıyla ilgilidir.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Botoks Fiyatları',
      slug: 'botoks-fiyatlari-neden-farkli',
      readTime: '8 dakika',
      publishDate: '21 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 9,
      title: '⏱️ Botoks Ne Kadar Süre Gider?',
      excerpt: 'Botoksun etkisi ne kadar sürer? Ortalama kalıcılık süresi, etkisini azaltan faktörler ve sonuçları uzun ömürlü kılmanın yolları.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Botoks Etki Süresi',
      slug: 'botoks-ne-kadar-sure-gider',
      readTime: '6 dakika',
      publishDate: '22 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 10,
      title: '✨ Mezoterapinin Etkileri Ne Zaman Görülür?',
      excerpt: 'Mezoterapi yaptırdıktan sonra etkiler ne zaman ortaya çıkar? İlk sonuçların görünme süresi, kalıcılık dönemi ve seans aralıkları hakkında tüm detaylar.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Mezoterapi',
      slug: 'mezoterapi-etkileri-ne-zaman-gorulur',
      readTime: '7 dakika',
      publishDate: '23 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 11,
      title: 'Dolgu İşlemleri Yüz Liftingi Sağlar mı?',
      excerpt: 'Dolgu işlemleri yüz liftingi etkisi yaratır mı? Hangi bölgelerde uygulanır, ne kadar süre kalıcıdır? Cerrahi olmayan yüz gençleştirmenin bilimsel açıklaması.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Dolgu & Lifting',
      slug: 'dolgu-islemleri-yuz-liftingi-saglar-mi',
      readTime: '9 dakika',
      publishDate: '24 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 12,
      title: 'Sıvı Yüz Germe Nedir, Hangi İçerikli Ürünler Kullanılır?',
      excerpt: 'Sıvı yüz germe işlemi nedir, nasıl yapılır, hangi içerikler kullanılır? Hyaluronik asit, kolajen ve vitamin karışımlarıyla ameliyatsız yüz gençleştirmenin modern yöntemi.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Sıvı Yüz Germe',
      slug: 'sivi-yuz-germe-nedir-hangi-icerikli-urunler-kullanilir',
      readTime: '10 dakika',
      publishDate: '25 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 13,
      title: 'Estetik İşlemlerin Etkisini Azaltan Hastalıklar',
      excerpt: 'Botoks, dolgu, mezoterapi gibi estetik işlemler herkes için aynı sonucu vermez. Tansiyon, diyabet, tiroid ve bazı ilaçlar işlemin etkisini azaltabilir. Detaylar burada.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Estetik & Sağlık',
      slug: 'estetik-islemlerin-etkisini-azaltan-hastaliklar',
      readTime: '11 dakika',
      publishDate: '26 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 14,
      title: '6 Nokta Lifting Nedir? Yüz Gençleştirmede Yeni Nesil Teknik',
      excerpt: '6 Nokta Lifting, yüzün stratejik bölgelerine uygulanan özel dolgu tekniğiyle cerrahi olmayan lifting etkisi sağlar. Nasıl yapılır, kimlere uygundur, kalıcılığı ne kadardır?',
      image: '/images/terleme-tedavisi.webp',
      category: '6 Nokta Lifting',
      slug: '6-nokta-lifting-nedir-yuz-genclestirmede-yeni-nesil-teknik',
      readTime: '8 dakika',
      publishDate: '27 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 15,
      title: 'Kaç Yaşında Botoks Yapmalıyım? — Botoksa Başlama Yaşı Rehberi',
      excerpt: 'Botoksa başlamak için ideal yaş kaçtır? Önleyici botoks nedir, hangi yaşta yapılmalıdır? Kırışıklıkların oluşumuna göre yaş bazlı öneriler.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Botoks Yaşı',
      slug: 'kac-yasinda-botoks-yapmaliyim-botoksa-baslama-yasi-rehberi',
      readTime: '11 dakika',
      publishDate: '28 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 16,
      title: 'Dudağa Botoks Uygulaması Nedir, Nasıl Yapılır?',
      excerpt: 'Dudağa botoks (lip flip) uygulaması nedir, nasıl yapılır? Dudak hacmini doğal biçimde belirginleştiren bu tekniğin farkı, süresi ve avantajları.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Dudak Estetiği',
      slug: 'dudaga-botoks-uygulamasi-nedir-nasil-yapilir',
      readTime: '9 dakika',
      publishDate: '29 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 17,
      title: 'Çeneye Botoks Uygulaması Nedir, Nasıl Yapılır?',
      excerpt: 'Çeneye botoks uygulaması ne işe yarar? Çene hattını incelten, diş sıkmayı azaltan ve yüz oranlarını dengeleyen bu işlemin etkileri ve süresi.',
      image: '/images/terleme-tedavisi.webp',
      category: 'V-Line Estetik',
      slug: 'ceneye-botoks-uygulamasi-nedir-nasil-yapilir',
      readTime: '8 dakika',
      publishDate: '30 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 18,
      title: 'Ayak Terlemesi İçin Botoks Tedavisi',
      excerpt: 'Aşırı ayak terlemesi (plantar hiperhidroz) botoks ile tedavi edilebilir mi? Etki süresi, avantajları ve uygulama süreci hakkında tüm detaylar burada.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Terleme Tedavisi',
      slug: 'ayak-terlemesi-icin-botoks-tedavisi',
      readTime: '7 dakika',
      publishDate: '31 Ocak 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 19,
      title: 'Koltuk Altı Terlemesi İçin Botoks Tedavisi',
      excerpt: 'Koltuk altı terlemesi (aksiller hiperhidroz) botoks ile nasıl tedavi edilir? Etkisi ne kadar sürer, kimlere uygulanabilir? Tüm detaylar burada.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Terleme Tedavisi',
      slug: 'koltuk-alti-terlemesi-icin-botoks-tedavisi',
      readTime: '6 dakika',
      publishDate: '1 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 20,
      title: 'Alın Bölgesine Dolgu Uygulaması Nedir, Nasıl Yapılır?',
      excerpt: 'Alın dolgusu kırışıklıkları azaltır, yüz hatlarını dengeleyip genç görünüm sağlar. Nasıl yapılır, hangi dolgu maddeleri kullanılır, etkisi ne kadar sürer?',
      image: '/images/terleme-tedavisi.webp',
      category: 'Dolgu & Lifting',
      slug: 'alin-bolgesine-dolgu-uygulamasi-nedir-nasil-yapilir',
      readTime: '7 dakika',
      publishDate: '2 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 21,
      title: 'Liposuction Zayıflama Yöntemi midir? Gerçekler ve Yanılgılar',
      excerpt: 'Liposuction kilo verme yöntemi midir? Yağ aldırma işlemi zayıflatır mı yoksa sadece şekillendirir mi? Liposuction hakkında doğru bilinen yanlışlar.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Estetik Cerrahi',
      slug: 'liposuction-zayiflama-yontemi-midir-gercekler-ve-yanilgilar',
      readTime: '8 dakika',
      publishDate: '3 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 22,
      title: 'Ameliyatsız Yüz Germe Yöntemleri',
      excerpt: 'Ameliyatsız yüz germe yöntemleri nelerdir? Botoks, dolgu, ip askı, HIFU, mezoterapi gibi modern tekniklerle genç ve sıkı bir cilt mümkün!',
      image: '/images/terleme-tedavisi.webp',
      category: 'Yüz Germe',
      slug: 'ameliyatsiz-yuz-germe-yontemleri',
      readTime: '9 dakika',
      publishDate: '5 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 23,
      title: 'Düşük Göz Kapağında Botoks Kullanımı',
      excerpt: 'Göz kapağı düşüklüğü botoks ile tedavi edilebilir mi? Düşük kaş ve üst göz kapağı sarkmalarında botoksun etkisi, uygulanma alanları ve dikkat edilmesi gerekenler.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Botoks & Göz',
      slug: 'dusuk-goz-kapaginda-botoks-kullanimi',
      readTime: '6 dakika',
      publishDate: '7 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 24,
      title: 'Botoksun Duygusal Etkileri',
      excerpt: 'Botoks yalnızca kırışıklıkları değil, duyguların yüzümüzdeki izlerini de etkiler. Peki estetik bir işlem, insanın iç dünyasında neleri değiştirir?',
      image: '/images/terleme-tedavisi.webp',
      category: 'Psikolojik Etki',
      slug: 'botoksun-duygusal-etkileri',
      readTime: '8 dakika',
      publishDate: '8 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 25,
      title: 'Dolgunun Duygusal Etkileri (Mecazi)',
      excerpt: 'Dolgu yalnızca yüz hatlarını değil, duyguları da şekillendirir. Estetik müdahalelerin özgüven, özsaygı ve duygusal denge üzerindeki mecazi etkileri.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Duygusal Etki',
      slug: 'dolgunun-duygusal-etkileri-mecazi',
      readTime: '7 dakika',
      publishDate: '8 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 26,
      title: 'Diş Hekimlerinin Botoks Yapma Yetkisi',
      excerpt: 'Diş hekimleri botoks uygulayabilir mi? Türkiye\'de ve dünyada diş hekimlerinin botoks ve dolgu uygulama yetkisi hangi yasal çerçevede tanımlanır?',
      image: '/images/terleme-tedavisi.webp',
      category: 'Yasal Düzenleme',
      slug: 'dis-hekimlerinin-botoks-yapma-yetkisi',
      readTime: '6 dakika',
      publishDate: '8 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 27,
      title: 'Diş Gıcırdatma (Bruksizm) Tedavisinde Botoks',
      excerpt: 'Diş gıcırdatma (bruksizm) nedir, neden olur? Botoks tedavisiyle çene kaslarını gevşetmek, ağrıyı ve diş aşınmasını azaltmak mümkün mü?',
      image: '/images/terleme-tedavisi.webp',
      category: 'Fonksiyonel Tedavi',
      slug: 'dis-gicirdatma-bruksizm-tedavisinde-botoks',
      readTime: '7 dakika',
      publishDate: '8 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 28,
      title: 'Memeye Dolgu Uygulaması: Doğal Dolgunluk ve Şekillendirme',
      excerpt: 'Memeye dolgu uygulaması nedir? Yağ transferi ve hyaluronik asit dolgularla ameliyatsız meme büyütme nasıl yapılır, ne kadar kalıcıdır?',
      image: '/images/terleme-tedavisi.webp',
      category: 'Ameliyatsız Estetik',
      slug: 'memeye-dolgu-uygulamasi-dogal-dolgunluk-ve-sekillendirme',
      readTime: '8 dakika',
      publishDate: '8 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 29,
      title: 'En İyi Dolgu Markası: Klinik Güvenlik ve Kalıcılık Rehberi',
      excerpt: 'Dolgu yaptırmadan önce hangi markalar güvenilir? En iyi dolgu markaları, FDA onay durumları ve kullanım alanları nelerdir?',
      image: '/images/terleme-tedavisi.webp',
      category: 'Dolgu Markaları',
      slug: 'en-iyi-dolgu-markasi-klinik-guvenlik-ve-kalicilik-rehberi',
      readTime: '9 dakika',
      publishDate: '9 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 30,
      title: 'Orijinal Dolguyu Anlama Yöntemleri: Sahte Ürünlerden Nasıl Korunulur?',
      excerpt: 'Dolgu yaptırmadan önce kullanılan ürünün orijinal olduğunu nasıl anlarsınız? Sahte dolgu ürünlerinin farkı nedir, nelere dikkat edilmelidir?',
      image: '/images/terleme-tedavisi.webp',
      category: 'Güvenlik',
      slug: 'orijinal-dolgu-anlama-yontemleri-sahte-urunlerden-korunma',
      readTime: '8 dakika',
      publishDate: '10 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 31,
      title: 'Orijinal Botoksu Anlama Yöntemleri: Güvenli Ürün Nasıl Tespit Edilir?',
      excerpt: 'Orijinal botoks nasıl anlaşılır? Sahte botoksun farkı nedir ve kullanılan ürünün güvenli olduğunu nasıl kontrol edebilirsiniz?',
      image: '/images/terleme-tedavisi.webp',
      category: 'Güvenlik',
      slug: 'orijinal-botoks-anlama-yontemleri-guvenli-urun-tespit-etme',
      readTime: '7 dakika',
      publishDate: '11 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 32,
      title: 'Botoks Etkisinin Süresi: Ne Kadar Kalıcıdır?',
      excerpt: 'Botoksun etkisi ne kadar sürer? Kalıcılık süresini etkileyen faktörler, etki süresini uzatmanın yolları ve tekrar uygulama zamanlaması.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Botoks Etki Süresi',
      slug: 'botoks-etkisinin-suresi-ne-kadar-kalicidir',
      readTime: '6 dakika',
      publishDate: '12 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 33,
      title: 'Dolgunun Erime Süresi: Ne Zaman ve Neden Azalır?',
      excerpt: 'Dolgu ne kadar sürer? Dolgunun erime süresini etkileyen faktörler, kalıcılığı azaltan nedenler ve etki süresini uzatmanın yolları.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Dolgu Kalıcılığı',
      slug: 'dolgunun-erime-suresi-ne-zaman-ve-neden-azalir',
      readTime: '7 dakika',
      publishDate: '13 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 34,
      title: 'Migren Tedavisinde Botoks: Bilimsel ve Klinik Yaklaşım',
      excerpt: 'Migren tedavisinde botoks nasıl kullanılır? Kronik migren tedavisinde botulinum toksinin etkisi, uygulama protokolü ve başarı oranları.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Tıbbi Tedavi',
      slug: 'migren-tedavisinde-botoks-bilimsel-ve-klinik-yaklasim',
      readTime: '10 dakika',
      publishDate: '14 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 35,
      title: 'Kronik Baş Ağrısı Tedavisinde Botoks',
      excerpt: 'Kronik baş ağrısı tedavisinde botoks etkili midir? Botulinum toksin ile baş ağrısı tedavisi, uygulama alanları ve etki mekanizması.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Tıbbi Tedavi',
      slug: 'kronik-bas-agrisi-tedavisinde-botoks',
      readTime: '8 dakika',
      publishDate: '15 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 36,
      title: 'Dolgu ile Meme Dikleştirme Nedir?',
      excerpt: 'Dolgu ile meme dikleştirme nasıl yapılır? Ameliyatsız meme büyütme ve şekillendirme, hyaluronik asit dolgularla doğal görünüm.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Meme Estetiği',
      slug: 'dolgu-ile-meme-diklestirme-nedir',
      readTime: '6 dakika',
      publishDate: '16 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 37,
      title: 'Burun Dolgusu ile Ameliyatsız Burun Düzeltme',
      excerpt: 'Burun dolgusu ile ameliyatsız burun düzeltme nasıl yapılır? Non-surgical rhinoplasty, burun şekillendirme ve dolgu uygulamaları.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Burun Estetiği',
      slug: 'burun-dolgusu-ile-ameliyatsiz-burun-duzeltme',
      readTime: '7 dakika',
      publishDate: '17 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 38,
      title: 'Ameliyatsız Yüz Germe İşlemlerinin Etkinliği',
      excerpt: 'Ameliyatsız yüz germe işlemleri ne kadar etkilidir? HIFU, RF, botoks, dolgu ve diğer non-surgical yöntemlerin başarı oranları.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Yüz Germe',
      slug: 'ameliyatsiz-yuz-germe-islemlerinin-etkinligi',
      readTime: '9 dakika',
      publishDate: '18 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 39,
      title: 'Hamilelikte Botoks: Bilimsel Gerçekler, Riskler ve Uzman Görüşü',
      excerpt: 'Hamilelikte botoks yapılır mı? Botulinum toksininin gebelikte güvenliği, olası riskleri, hormonel değişikliklerin etkisi ve uzman önerileri.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Hamilelik & Güvenlik',
      slug: 'hamilelikte-botoks-bilimsel-gercekler-riskler-ve-uzman-gorusu',
      readTime: '10 dakika',
      publishDate: '16 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 40,
      title: 'Hamilelikte Dolgu: Bilimsel Veriler, Riskler ve Uzman Yaklaşımı',
      excerpt: 'Hamilelikte dolgu yaptırmak güvenli mi? Hyaluronik asit dolguların gebelikteki etkileri, bilimsel çalışmalar, riskler ve uzman önerileri.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Hamilelik & Güvenlik',
      slug: 'hamilelikte-dolgu-bilimsel-veriler-riskler-ve-uzman-yaklasimi',
      readTime: '9 dakika',
      publishDate: '17 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
    {
      id: 41,
      title: 'Emzirme Döneminde Dolgu: Güvenli mi, Ertelenmeli mi?',
      excerpt: 'Emzirme döneminde dolgu yaptırmak güvenli midir? Hyaluronik asit dolguların sütle geçiş olasılığı, olası riskler ve uzman önerileri.',
      image: '/images/terleme-tedavisi.webp',
      category: 'Emzirme & Güvenlik',
      slug: 'emzirme-doneminde-dolgu-guvenli-mi-ertelenmeli-mi',
      readTime: '8 dakika',
      publishDate: '18 Şubat 2026',
      author: 'Op. Dr. Barış Çin'
    },
        {
          id: 42,
          title: 'Emzirme Döneminde Botoks: Bilimsel Gerçekler, Riskler ve Güvenli Zamanlama',
          excerpt: 'Emzirme döneminde botoks yaptırmak güvenli mi? Botulinum toksinin anne sütüne geçip geçmediği, risk faktörleri ve uzman önerileri.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Emzirme & Güvenlik',
          slug: 'emzirme-doneminde-botoks-bilimsel-gercekler-riskler-ve-guvenli-zamanlama',
          readTime: '9 dakika',
          publishDate: '19 Şubat 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 43,
          title: 'Kış Aylarında Uygulanan Mezoterapiler: Soğuk Havada Cilt Yenilenmesi',
          excerpt: 'Kış mevsiminde mezoterapi neden daha etkili olur? Soğuk havada cilt kuruluğunu ve matlığı gideren özel mezoterapi protokolleri.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Mezoterapi & Cilt Bakımı',
          slug: 'kis-aylarinda-uygulanan-mezoterapiler-soguk-havada-cilt-yenilenmesi',
          readTime: '6 dakika',
          publishDate: '21 Şubat 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 44,
          title: 'Mezoterapinin İğneli Bir İşlem Olması: Gerçekler, Faydalar ve Güvenlik',
          excerpt: 'Mezoterapinin iğneli bir işlem olmasının avantajları nelerdir? Ağrı, kızarıklık, iyileşme süreci ve steril uygulama detayları.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Mezoterapi & Güvenlik',
          slug: 'mezoterapinin-igneli-bir-islem-olmasi-gercekler-faydalar-ve-guvenlik',
          readTime: '8 dakika',
          publishDate: '22 Şubat 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 45,
          title: 'Dudak Dolgusu Teknikleri: Doğal, Simetrik ve Estetik Sonuçlar',
          excerpt: 'Dudak dolgusu nasıl yapılır? Russian Lips, Paris Lips, Volume Lips gibi tekniklerin farkları ve yüz tipine göre dolgu seçimi.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Dudak Estetiği',
          slug: 'dudak-dolgusu-teknikleri-dogal-simetrik-ve-estetik-sonuclar',
          readTime: '7 dakika',
          publishDate: '23 Şubat 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 46,
          title: 'Cilt Kuruluğunda Mezoterapi: Derin Nem Desteği ve Hücresel Yenilenme',
          excerpt: 'Cilt kuruluğuna karşı mezoterapi nasıl etki eder? Hyaluronik asit, vitamin ve mineral kokteylleriyle ciltte derin nem ve elastikiyet artışı.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Mezoterapi & Cilt Bakımı',
          slug: 'cilt-kurulugunda-mezoterapi-derin-nem-destegi-ve-hucresel-yenilenme',
          readTime: '7 dakika',
          publishDate: '20 Şubat 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 47,
          title: 'En İyi Dudak Dolgusu Markası: Doğallık, Kalıcılık ve Güven',
          excerpt: 'En iyi dudak dolgusu markası hangisidir? Kalıcılığı, doğallığı, FDA onayı ve güvenilirliğiyle öne çıkan dudak dolgularının karşılaştırması.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Dudak Estetiği',
          slug: 'en-iyi-dudak-dolgusu-markasi-dogallik-kalicilik-ve-guven',
          readTime: '8 dakika',
          publishDate: '24 Şubat 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 48,
          title: 'Estetik İşlemlerde Para İadesi: Mümkün mü?',
          excerpt: 'Estetik işlemlerde memnun kalınmazsa para iadesi yapılır mı? Tıbbi hizmetlerde iade hakkı, etik kurallar ve yasal dayanaklar.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Hasta Hakları & Hukuk',
          slug: 'estetik-islemlerde-para-iadesi-mumkun-mu',
          readTime: '6 dakika',
          publishDate: '25 Şubat 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 49,
          title: 'Göz Altı Işık Dolgusuna Uygunluk: Kimler İçin İdeal, Kimler İçin Değil?',
          excerpt: 'Göz altı ışık dolgusu herkese yapılabilir mi? Uygun aday kriterleri, riskli durumlar ve dikkat edilmesi gereken noktalar.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Göz Altı Estetiği',
          slug: 'goz-alti-isik-dolgusuna-uygunluk-kimler-icin-ideal-kimler-icin-degil',
          readTime: '7 dakika',
          publishDate: '26 Şubat 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 50,
          title: 'Işık Dolgusunun Göz Altı Morluklarına Etkisi',
          excerpt: 'Göz altı morlukları için ışık dolgusu ne kadar etkilidir? Sebeplerine göre değişen sonuçlar, etki süresi ve uzman önerileri.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Göz Altı Estetiği',
          slug: 'isik-dolgusunun-goz-alti-morluklarina-etkisi',
          readTime: '6 dakika',
          publishDate: '27 Şubat 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 51,
          title: 'Botoks Sonrası Alkol Tüketimi: Bilimsel Açıklamalar, Klinik Etkiler ve Uzman Önerileri',
          excerpt: 'Botoks sonrası alkol içmek neden önerilmez? Dolaşım, kas aktivitesi ve ödem üzerindeki biyolojik etkiler ile bilimsel bekleme süreleri.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Botoks Bakımı',
          slug: 'botoks-sonrasi-alkol-tuketimi-bilimsel-aciklamalar-klinik-etkiler-ve-uzman-onerileri',
          readTime: '8 dakika',
          publishDate: '28 Şubat 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 52,
          title: 'Dudak Dolgusu Sonrası Alkol Tüketimi: Bilimsel Etkiler, Klinik Bulgular ve Estetik Sonuçlar',
          excerpt: 'Dudak dolgusu sonrası alkol neden önerilmez? Hyaluronik asit dengesi, damar geçirgenliği, morarma ve şişlik üzerindeki bilimsel etkiler.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Dudak Estetiği',
          slug: 'dudak-dolgusu-sonrasi-alkol-tuketimi-bilimsel-etkiler-klinik-bulgular-ve-estetik-sonuclar',
          readTime: '7 dakika',
          publishDate: '1 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 53,
          title: 'Dudak Dolgusu Sonrası Alkol Alımının Sonuçları',
          excerpt: 'Dudak dolgu işleminden sonra alkol tüketimi hangi sonuçlara yol açar? Morarma, ödem, asimetrik görünüm ve dolgu yer değişimi üzerine bilimsel açıklamalar.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Dudak Estetiği',
          slug: 'dudak-dolgusu-sonrasi-alkol-aliminin-sonuclari',
          readTime: '6 dakika',
          publishDate: '2 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 54,
          title: 'Botoks Sonrası Alkol Alımının Sonuçları: Bilimsel Etkiler, Klinik Bulgular ve Estetik Riskler',
          excerpt: 'Botoks sonrası alkol alınırsa ne olur? Kas asimetrisi, morarma, ödem ve etki kaybı riskleri hakkında bilimsel ve klinik açıklama.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Botoks Bakımı',
          slug: 'botoks-sonrasi-alkol-aliminin-sonuclari-bilimsel-etkiler-klinik-bulgular-ve-estetik-riskler',
          readTime: '9 dakika',
          publishDate: '3 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 55,
          title: 'Yüz Dolgusu Sonrası Alkol Alımının Sonuçları',
          excerpt: 'Yüz dolgu uygulamasından sonra alkol içmek neden sakıncalıdır? Morarma, ödem, dolgu yer değişimi ve doku hassasiyeti üzerindeki etkiler.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Dolgu Bakımı',
          slug: 'yuz-dolgusu-sonrasi-alkol-aliminin-sonuclari',
          readTime: '7 dakika',
          publishDate: '4 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 56,
          title: 'Yüz Dolgusu Sonrası Uçak Seyahati: Basınç Değişimi, Ödem Riski ve Uzman Önerileri',
          excerpt: 'Yüz dolgu işleminden hemen sonra uçağa binmek doğru mu? Basınç, dolaşım ve ödem üzerindeki etkiler ve bilimsel açıklamalar.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Dolgu Bakımı',
          slug: 'yuz-dolgusu-sonrasi-ucak-seyahati-basinc-degisimi-odem-riski-ve-uzman-onerileri',
          readTime: '8 dakika',
          publishDate: '5 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 57,
          title: 'Botoksun Alerji Riski: Gerçek Tehlike mi, Yanlış Algı mı?',
          excerpt: 'Botoks alerjisi gerçekten olur mu? Belirtileri, risk faktörleri ve alerji testinin önemi — bilimsel veriler ve klinik gözlemlerle açıklanıyor.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Botoks Güvenliği',
          slug: 'botoksun-alerji-riski-gercek-tehlike-mi-yanlis-algi-mi',
          readTime: '9 dakika',
          publishDate: '6 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 58,
          title: 'Dudak Dolgusunun Alerji Riski: Gerçek Olgular, Yanlış Algılar ve Güvenli Uygulama',
          excerpt: 'Dudak dolgu alerji yapar mı? Hyaluronik asit reaksiyonları, bağışıklık sistemi yanıtı ve güvenli uygulama kriterleri.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Dudak Estetiği',
          slug: 'dudak-dolgusunun-alerji-riski-gercek-olgular-yanlis-algilar-ve-guvenli-uygulama',
          readTime: '10 dakika',
          publishDate: '7 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 59,
          title: 'Yüz Dolgusunun Alerji Riski: Nadir Ama Bilinmesi Gereken Gerçekler',
          excerpt: 'Yüz dolgu işlemleri alerji yapar mı? Belirtiler, risk grupları ve doğru ürün seçimi üzerine bilimsel ve klinik açıklamalar.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Dolgu Güvenliği',
          slug: 'yuz-dolgusunun-alerji-riski-nadir-ama-bilinmesi-gereken-gercekler',
          readTime: '8 dakika',
          publishDate: '8 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 60,
          title: 'Yüz Dolgusu Sonrası Dikkat Edilmesi Gerekenler: Bilimsel ve Klinik Rehber',
          excerpt: 'Yüz dolgusu sonrasında nelere dikkat edilmelidir? Masaj, uyku, alkol, egzersiz, uçuş ve beslenme dâhil tüm kuralların bilimsel açıklaması.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Dolgu Bakımı',
          slug: 'yuz-dolgusu-sonrasi-dikkat-edilmesi-gerekenler-bilimsel-ve-klinik-rehber',
          readTime: '12 dakika',
          publishDate: '9 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 61,
          title: 'Dudak Dolgusu Sonrası Öpüşme: Bilimsel, Estetik ve Duygusal Bir Rehber',
          excerpt: 'Dudak dolgusu sonrası öpüşmek ne zaman güvenlidir? Dolgunun kayması, enfeksiyon ve estetik riskler hakkında bilimsel açıklama ve uzman önerileri.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Dudak Estetiği',
          slug: 'dudak-dolgusu-sonrasi-opusme-bilimsel-estetik-ve-duygusal-bir-rehber',
          readTime: '11 dakika',
          publishDate: '10 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 62,
          title: 'Güzellik Merkezlerinin Botoks Yapma Yetkisi: Yasal Durum ve Klinik Gerçekler',
          excerpt: 'Güzellik merkezleri botoks yapabilir mi? Sağlık Bakanlığı yönetmelikleri, yasal yetki sınırları ve hastaların bilinmesi gerekenler.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Yasal Durum',
          slug: 'guzellik-merkezlerinin-botoks-yapma-yetkisi-yasal-durum-ve-klinik-gercekler',
          readTime: '13 dakika',
          publishDate: '11 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 63,
          title: 'Yüze Dolgu Yapan Doktorlar: Hangi Branş Yetkilidir, Nasıl Seçim Yapılmalı?',
          excerpt: 'Yüze dolgu işlemini kim yapabilir? Hangi doktorlar yasal olarak dolgu uygulaması yapma yetkisine sahiptir? Uzmanlık farkları, güvenli seçim kriterleri ve klinik uyarılar.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Doktor Seçimi',
          slug: 'yuze-dolgu-yapan-doktorlar-hangi-brans-yetkilidir-nasil-secim-yapilmali',
          readTime: '15 dakika',
          publishDate: '12 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 64,
          title: 'Botoks Yapan Doktorlar: Hangi Branş Yetkilidir, Kimler Uygulama Yapabilir?',
          excerpt: 'Botoks kim tarafından yapılabilir? Hangi doktorlar botoks uygulama yetkisine sahiptir? Plastik cerrah, dermatolog, medikal estetik hekimi farklarıyla kapsamlı rehber.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Doktor Seçimi',
          slug: 'botoks-yapan-doktorlar-hangi-brans-yetkilidir-kimler-uygulama-yapabilir',
          readTime: '16 dakika',
          publishDate: '13 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 65,
          title: 'Göz Altı Dolgusunun Tehlikeleri: Bilimsel Gerçekler ve Güvenli Uygulama Kriterleri',
          excerpt: 'Göz altı dolgusu riskli mi? Tyndall etkisi, damar tıkanması, morarma ve enfeksiyon gibi tehlikeler — bilimsel ve klinik açıklamalarla ele alındı.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Güvenlik',
          slug: 'goz-alti-dolgusunun-tehlikeleri-bilimsel-gercekler-ve-guvenli-uygulama-kriterleri',
          readTime: '18 dakika',
          publishDate: '14 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 66,
          title: 'Göz Altı Dolgusunun Önerilmediği Durumlar: Kimler İçin Uygun Değil?',
          excerpt: 'Göz altı dolgusu her hastaya uygun mudur? Hangi durumlarda dolgu yapılmamalı veya ertelenmelidir? Uzman görüşüyle güvenli hasta seçimi rehberi.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Hasta Seçimi',
          slug: 'goz-alti-dolgusunun-onerilmedigi-durumlar-kimler-icin-uygun-degil',
          readTime: '17 dakika',
          publishDate: '15 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        },
        {
          id: 67,
          title: 'Alt Göz Kapağı Ameliyatında İz Kalması: Gerçek mi, Korku mu?',
          excerpt: 'Alt göz kapağı estetiği (blefaroplasti) sonrasında iz kalır mı? Kesinin yeri, cilt tipi, dikiş tekniği ve iyileşme süreci hakkında tüm bilimsel detaylar.',
          image: '/images/terleme-tedavisi.webp',
          category: 'Estetik Cerrahi',
          slug: 'alt-goz-kapagi-ameliyatinda-iz-kalmasi-gercek-mi-korku-mu',
          readTime: '19 dakika',
          publishDate: '16 Mart 2026',
          author: 'Op. Dr. Barış Çin'
        }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        {/* Breadcrumb */}
        <div className="mb-8">
          <Breadcrumb
            items={[
              { label: 'Ana Sayfa', href: '/tr' },
              { label: 'Blog', href: '/tr/blog' },
            ]}
          />
        </div>

        {/* Hero Section */}
        <div className="text-center mb-12 mt-12">
          <h1 className="text-4xl sm:text-5xl font-bold text-center mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600">
            Dr. Barış Çin Blog
          </h1>
          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto">
            Plastik cerrahi, estetik tedaviler ve güzellik hakkında güncel bilgiler, uzman görüşleri ve ipuçları
          </p>
        </div>

        {/* Categories */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <button className="px-6 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors">
            Tüm Yazılar
          </button>
          <button className="px-6 py-2 bg-white text-gray-600 rounded-full hover:bg-gray-50 transition-colors border">
            Estetik Tedaviler
          </button>
          <button className="px-6 py-2 bg-white text-gray-600 rounded-full hover:bg-gray-50 transition-colors border">
            Cerrahi İşlemler
          </button>
          <button className="px-6 py-2 bg-white text-gray-600 rounded-full hover:bg-gray-50 transition-colors border">
            Bakım Önerileri
          </button>
        </div>

        {/* Blog Posts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <Link
              key={post.id}
              href={post.slug ? `/tr/blog/${post.slug}` : '#'}
              className="group"
            >
              <article className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 group-hover:-translate-y-2">
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <Image
                    src={post.image}
                    alt={post.title}
                    fill
                    className="object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                      {post.category}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h2 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors line-clamp-2">
                    {post.title}
                  </h2>
                  
                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>

                  {/* Meta Information */}
                  <div className="flex items-center justify-between text-sm text-gray-500">
                    <div className="flex items-center space-x-4">
                      <div className="flex items-center">
                        <FaUser className="w-4 h-4 mr-1" />
                        <span>{post.author}</span>
                      </div>
                      <div className="flex items-center">
                        <FaClock className="w-4 h-4 mr-1" />
                        <span>{post.readTime}</span>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <FaCalendarAlt className="w-4 h-4 mr-1" />
                      <span>{post.publishDate}</span>
                    </div>
                  </div>
                </div>
              </article>
            </Link>
          ))}
        </div>

        {/* Empty State for More Posts */}
        <div className="text-center mt-12">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Daha Fazla İçerik Geliyor!
            </h3>
            <p className="text-gray-600 mb-6">
              Estetik cerrahi ve güzellik tedavileri hakkında daha fazla bilgilendirici içerik için bizi takip edin.
            </p>
            <Link
              href="/tr"
              className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors"
            >
              Ana Sayfaya Dön
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
} 